import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import * as Y from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { QrScanner } from 'react-qrcode-scanner'

import { useCreateCall } from '../../lib/api/create'
import { useUpdateCall } from '../../lib/api/update'

import checkIni from '../../assets/images/check-in-out.gif'
import { Link } from 'react-router-dom'
import { BioFPAttendance } from './Biometric'

export const CheckInOut = ({ isLocalEnvironment, routeData }) => {
  const [havePermission, setHavePermission] = React.useState(false)
  const [type, setType] = React.useState('auth')
  const [isError, setIsError] = React.useState(false)
  const [results, setResults] = React.useState(null)
  const [checkInit, setCheckInit] = React.useState(false)
  const [scanInits, setScanInits] = React.useState(false)
  const [sendSuccess, setSendSuccess] = React.useState(false)
  const [sendFailed, setSendFailed] = React.useState(false)

  const fpList = sessionStorage.getItem('auth') ? JSON.parse(sessionStorage.getItem('auth')) : null

  const getDeviceType = () => {
    var isMobile = /iphone|ipod|android|ie|blackberry|fennec/.test(
      navigator.userAgent.toLowerCase(),
    )
    const result = isMobile ? 'face' : 'environment'
    return result
  }
  const [camFacingMode, setCamFacingMode] = React.useState(getDeviceType())

  const createCallMutation = useCreateCall()
  const updateCallMutation = useUpdateCall()
  const modSchema = JSON.parse(routeData.apiEndPointSchema)
  const validationSchema = Y.object()
    .shape({
      ...modSchema.validation,
    })
    .required()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  })

  const scanInit = () => {
    if (scanInits !== true) {
      setResults(null)
    }
    setScanInits(!scanInits)
    results
  }

  const handleScan = async (data) => {
    setType(null)
    setCheckInit(true)
    if (data) {
      window.localStream.getVideoTracks()[0].stop()
      const callMutation = modSchema.type === 'CheckOut' ? updateCallMutation : createCallMutation
      const formData = {}
      formData['authCode'] = data.text
      if (modSchema.checkInOnly) {
        formData['attendanceType'] = 0
      } else {
        formData['attendanceType'] = modSchema.type === 'CheckOut' ? 2 : 0
      }
      await callMutation
        .mutateAsync({
          url: isLocalEnvironment + '/addData',
          apiEndpoint: modSchema.type === 'CheckOut' ? 'check-out' : 'check-in',
          data: formData,
          id: '',
          messageTitle: 'Attendance',
          message: 'Activity added successfully!',
          params: '',
          noConfirmation: true,
          isDynamic: true,
        })
        .then(() => {
          setType(null)
          setCheckInit(false)
          setSendSuccess(true)
          setTimeout(() => setSendSuccess(false), 10000)
        })
        .catch(() => {
          setCheckInit(false)
          setSendFailed(true)
          setTimeout(() => setSendFailed(false), 10000)
        })
    }
  }

  const onSubmitForm = async (data, e) => {
    setCheckInit(true)
    const formData = {}
    formData['authCode'] = data['authCode']
    if (modSchema.checkInOnly) {
      formData['attendanceType'] = 0
    } else {
      formData['attendanceType'] = modSchema.type === 'CheckOut' ? 2 : 0
    }
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: modSchema.type === 'CheckOut' ? 'check-out' : 'check-in',
        data: formData,
        id: '',
        messageTitle: 'Attendance',
        message: 'Activity added successfully!',
        params: '',
        noConfirmation: true,
        isDynamic: true,
      })
      .then(() => {
        setType(null)
        setCheckInit(false)
        setSendSuccess(true)
        setTimeout(() => setSendSuccess(false), 10000)
        e.target.reset()
      })
      .catch(() => {
        setCheckInit(false)
        setSendFailed(true)
        setTimeout(() => setSendFailed(false), 10000)
      })
  }

  const checkPermissions = (type) => {
    setType(type)
    const permissions = navigator.mediaDevices.getUserMedia({
      audio: false,
      video: true,
    })
    permissions
      .then((stream) => {
        window.localStream = stream
        scanInit()
        setHavePermission(!havePermission)
      })
      .catch(() => {
        setHavePermission(false)
        handleError()
      })
  }

  const authCode = (type) => {
    const element = document.getElementById('passcode')
    setTimeout(() => element.focus(), 0)
    //document.getElementById().focus()
    setType(type)
  }

  const setDone = () => {
    authCode('auth')
    setSendSuccess(false)
  }

  const setFailed = () => {
    authCode('auth')
    setSendFailed(false)
  }

  const handleError = () => {
    setIsError(!isError)
  }

  React.useEffect(() => {
    const element = document.getElementById('passcode')
    if (element) {
      setTimeout(() => element.focus(), 0)
    }
    const handleContextmenu = (e) => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu)
    }
  }, [])

  const urlPath = window.location.pathname
  const urlLink = urlPath.split('/organization/')

  if (modSchema.isBiometric) {
    return (
      <BioFPAttendance
        modSchema={modSchema}
        urlLink={urlLink}
        isLocalEnvironment={isLocalEnvironment}
        fpList={fpList}
        createCallMutation={createCallMutation}
      />
    )
  } else {
    return (
      <div key={modSchema.type} className="trtui-row trtui-justify-content-center">
        <div className="trtui-col-lg-8">
          <div className="trtui-card">
            <div className="trtui-card-body">
              <div className="trtui-text-center">
                <div className="trtui-row trtui-justify-content-center">
                  <div className="trtui-col-lg-12">
                    <h6 className="trtui-fw-semibold">
                      <Link
                        to={`/${urlLink.length && urlLink.length > 1 ? 'organization' : 'console'}/check-in`}
                      >
                        <button
                          type="button"
                          disabled={modSchema.type === 'CheckOut' ? false : true}
                          className="trtui-btn trtui-btn-primary trtui-mr-2"
                        >
                          Check In
                        </button>
                      </Link>{' '}
                      <Link
                        to={`/${urlLink.length && urlLink.length > 1 ? 'organization' : 'console'}/check-out`}
                      >
                        <button
                          type="button"
                          disabled={modSchema.type === 'CheckOut' ? true : false}
                          className="trtui-btn trtui-btn-primary trtui-ml-2"
                        >
                          Check Out
                        </button>
                      </Link>
                    </h6>
                    <h4 className="trtui-mt-2">
                      {modSchema.type === 'CheckOut' ? 'Check-Out' : 'Check-In'}
                    </h4>
                    <div className="trtui-card">
                      <div className="trtui-card-body">
                        <ul
                          key={type}
                          className="trtui-nav trtui-nav-tabs trtui-nav-justified trtui-nav-border-top trtui-nav-border-top-primary trtui-mb-3"
                          role="tablist"
                        >
                          <li className="trtui-nav-item" role="presentation">
                            <button
                              className={`trtui-nav-link ${type === 'qr' && 'trtui-active'}`}
                              data-bs-toggle="tab"
                              role="tab"
                              aria-selected="false"
                              onClick={() => checkPermissions('qr')}
                            >
                              <i className="ri-qr-code-line trtui-align-middle trtui-me-1" /> QR
                              Code
                            </button>
                          </li>
                          <li className="trtui-nav-item" role="presentation">
                            <button
                              className={`trtui-nav-link ${type === 'auth' && 'trtui-active'}`}
                              data-bs-toggle="tab"
                              role="tab"
                              aria-selected="true"
                              onClick={() => authCode('auth')}
                            >
                              <i className="ri-key-line trtui-me-1 trtui-align-middle" /> Passcode
                            </button>
                          </li>
                        </ul>
                        <div className="trtui-tab-content trtui-text-muted">
                          <div
                            className={`trtui-tab-pane ${type === 'qr' && 'trtui-active trtui-show'}`}
                            id="nav-border-justified-home"
                            role="tabpanel"
                          >
                            <QrScanner
                              onScan={handleScan}
                              onError={handleError}
                              facingMode={camFacingMode}
                              delay="800" //delay between each scan
                              resolution="600" //canvas resolution
                              aspectRatio="16:9"
                              showViewFinder={true}
                              viewFinder={{
                                border: '0px solid rgba(255,255,255,0.3)',
                                position: 'absolute',
                                borderRadius: '5px',
                                width: '30rem',
                                height: '20rem',
                              }}
                              setCamFacingMode={setCamFacingMode}
                            />
                            <div
                              className="scan-region-highlight"
                              style={{
                                position: 'absolute',
                                'pointer-events': 'none',
                                '-webkit-transform': 'scaleX(-1)',
                                '-ms-transform': 'scaleX(-1)',
                                transform: 'scaleX(-1)',
                                width: '80%',
                                height: '60%',
                                top: '26%',
                                left: '10%',
                              }}
                            >
                              <svg
                                className="scan-region-highlight-svg"
                                viewBox="0 0 238 238"
                                preserveAspectRatio="none"
                                style={{
                                  position: 'absolute',
                                  width: '100%',
                                  height: '100%',
                                  left: '0',
                                  top: '0',
                                  fill: 'none',
                                  stroke: '#e9b213',
                                  'stroke-width': '4',
                                  'stroke-linecap': 'round',
                                  'stroke-linejoin': 'round',
                                }}
                              >
                                <path d="M31 2H10a8 8 0 0 0-8 8v21M207 2h21a8 8 0 0 1 8 8v21m0 176v21a8 8 0 0 1-8 8h-21m-176 0H10a8 8 0 0 1-8-8v-21" />
                              </svg>
                              <svg
                                className="code-outline-highlight"
                                preserveAspectRatio="none"
                                style={{
                                  display: 'none',
                                  width: '100%',
                                  height: '100%',
                                  fill: 'none',
                                  stroke: '#e9b213',
                                  'stroke-width': '5',
                                  'stroke-dasharray': '25',
                                  'stroke-linecap': 'round',
                                  'stroke-linejoin': 'round',
                                }}
                              >
                                <polygon />
                              </svg>
                            </div>
                          </div>
                          <div
                            className={`trtui-tab-pane ${
                              type === 'auth' && 'trtui-active trtui-show'
                            }`}
                            id="nav-border-justified-profile"
                            role="tabpanel"
                          >
                            <form
                              onSubmit={handleSubmit(onSubmitForm)}
                              data-testid="formAdd"
                              className="trtui-row"
                            >
                              <div className="trtui-input-group trtui-mb-3">
                                <input
                                  id="passcode"
                                  type="password"
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  placeholder="Passcode"
                                  autoComplete="off"
                                  className={`trtui-form-control ${
                                    errors[modSchema.authCodeField] &&
                                    'trtui-form-control-danger trtui-height-unset'
                                  }`}
                                  {...register('authCode')}
                                />
                                <div className="trtui-input-group-append">
                                  <button
                                    className="trtui-btn trtui-btn-info trtui-text-white"
                                    type="submit"
                                    disabled={checkInit}
                                  >
                                    Go!
                                  </button>
                                </div>
                                {errors[modSchema.authCodeField] && (
                                  <div className="trtui-form-control-feedback">
                                    {errors[modSchema.authCodeField].message}
                                  </div>
                                )}
                              </div>
                            </form>
                          </div>
                          {checkInit && (
                            <img
                              src={checkIni}
                              style={{ width: '100%' }}
                              alt=""
                              className="trtui-img-fluid"
                            />
                          )}
                          {sendSuccess && (
                            <div className="trtui-modal-body trtui-text-center trtui-p-4 trtui-pb-5">
                              <i className="icon icon-check trtui-fs-70 ttrtui-ext-success trtui-lh-1 trtui-my-4 trtui-d-inline-block" />{' '}
                              <h4 className="trtui-text-success trtui-mb-4">{`Checked-${
                                modSchema.type === 'CheckOut' ? 'Out' : 'In'
                              }`}</h4>{' '}
                              <p className="mb-4 mx-4">{`Your child is checked-${
                                modSchema.type === 'CheckOut' ? 'out' : 'in'
                              }!`}</p>
                              <button
                                className="trtui-btn trtui-btn-success trtui-pd-x-25"
                                onClick={() => setDone()}
                              >
                                Done
                              </button>{' '}
                            </div>
                          )}
                          {sendFailed && (
                            <div className="trtui-modal-body trtui-text-center trtui-p-4 trtui-pb-5">
                              <i className="icon icon-close trtui-fs-70 trtui-text-danger trtui-lh-1 trtui-my-4 trtui-d-inline-block" />{' '}
                              <h4 className="trtui-text-danger trtui-mb-4">{`Check-${
                                modSchema.type === 'CheckOut' ? 'Out' : 'In'
                              }`}</h4>{' '}
                              <p className="mb-4 mx-4">{`Your child could not be checked-${
                                modSchema.type === 'CheckOut' ? 'out' : 'in'
                              }!`}</p>
                              <button
                                className="trtui-btn trtui-btn-danger trtui-pd-x-25"
                                onClick={() => setFailed()}
                              >
                                Try Again
                              </button>{' '}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* end card-body */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CheckInOut.propTypes = {
  modSchema: PropTypes.object,
  routeData: PropTypes.object,
  data: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
